import { signInAnonymously } from "firebase/auth";
import {
  doc,
  runTransaction,
  serverTimestamp,
} from "firebase/firestore";
import { auth, db } from "../firebase/firebase";

let visitorRequest;

export function getKoreanDateKey(date = new Date()) {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Seoul",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);
  const values = Object.fromEntries(
    parts.map(({ type, value }) => [type, value]),
  );

  return Number(`${values.year}${values.month}${values.day}`);
}

async function getAnonymousUser() {
  await auth.authStateReady();

  if (auth.currentUser) {
    return auth.currentUser;
  }

  const credential = await signInAnonymously(auth);
  return credential.user;
}

async function updateVisitorCount() {
  const user = await getAnonymousUser();
  const dateKey = getKoreanDateKey();
  const counterRef = doc(db, "visitorCounters", "current");
  const markerRef = doc(db, "visitorMarkers", user.uid);

  return runTransaction(db, async (transaction) => {
    const markerSnapshot = await transaction.get(markerRef);
    const counterSnapshot = await transaction.get(counterRef);
    const counter = counterSnapshot.exists() ? counterSnapshot.data() : {};

    if (markerSnapshot.exists() && markerSnapshot.data().dateKey === dateKey) {
      return {
        today: counter.dateKey === dateKey ? counter.today : 0,
        total: counter.total ?? 0,
      };
    }

    const nextCount = {
      dateKey,
      today: counter.dateKey === dateKey ? (counter.today ?? 0) + 1 : 1,
      total: (counter.total ?? 0) + 1,
      updatedAt: serverTimestamp(),
    };

    transaction.set(markerRef, {
      dateKey,
      updatedAt: serverTimestamp(),
    });
    transaction.set(counterRef, nextCount);

    return {
      today: nextCount.today,
      total: nextCount.total,
    };
  });
}

export function registerVisitor() {
  if (!visitorRequest) {
    visitorRequest = updateVisitorCount().catch((error) => {
      visitorRequest = undefined;
      throw error;
    });
  }

  return visitorRequest;
}
